(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["box-cover-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const states = window.__andmoreBoxCoverState || (window.__andmoreBoxCoverState = new Map());

    class BoxCoverPicker extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;

        this._connected = true;
        this._stateKey = this.dataset.productId;
        this._withBox = states.get(this._stateKey) === true;
        this._syncQueued = false;
        this._root = this.closest('product-rerender') || this.closest('.shopify-section') || document.documentElement;
        this._onChoiceChange = this._onChoiceChange.bind(this);
        this._onKachingChange = this._onKachingChange.bind(this);
        this._onQuantityChange = this._onQuantityChange.bind(this);
        this._onClick = this._onClick.bind(this);
        this._onSubmit = this._onSubmit.bind(this);

        this.querySelectorAll('[data-box-cover-choice]').forEach((input) => {
          input.addEventListener('change', this._onChoiceChange);
        });

        window.addEventListener('click', this._onClick, true);
        window.addEventListener('submit', this._onSubmit, true);
        document.addEventListener('input', this._onQuantityChange, true);
        document.addEventListener('change', this._onQuantityChange, true);
        document.addEventListener('deal-bar-selected', this._onKachingChange);
        document.addEventListener('items-changed', this._onKachingChange);
        window.addEventListener('kaching-bundles-initialized', this._onKachingChange);

        this._observer = new MutationObserver(() => this._queueSync());
        this._observer.observe(this._root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });

        const nativeWithoutBox = this.querySelector('[data-box-cover-native-without-box]');
        if (this.dataset.forceWithoutBox === 'true' && nativeWithoutBox) {
          requestAnimationFrame(() => nativeWithoutBox.dispatchEvent(new Event('change', { bubbles: true })));
        }

        this._queueSync();
      }

      disconnectedCallback() {
        this.querySelectorAll('[data-box-cover-choice]').forEach((input) => {
          input.removeEventListener('change', this._onChoiceChange);
        });

        window.removeEventListener('click', this._onClick, true);
        window.removeEventListener('submit', this._onSubmit, true);
        document.removeEventListener('input', this._onQuantityChange, true);
        document.removeEventListener('change', this._onQuantityChange, true);
        document.removeEventListener('deal-bar-selected', this._onKachingChange);
        document.removeEventListener('items-changed', this._onKachingChange);
        window.removeEventListener('kaching-bundles-initialized', this._onKachingChange);
        this._observer?.disconnect();
        this._root?.removeAttribute('data-box-cover-with-box');
        this._connected = false;
      }

      get _form() {
        return document.getElementById(this.dataset.formId);
      }

      get _coverStock() {
        return Math.max(0, Number.parseInt(this.dataset.coverStock || '0', 10) || 0);
      }

      get _selectedBar() {
        return this._root.querySelector('.kaching-bundles__bar--selected');
      }

      _onChoiceChange(event) {
        this._withBox = event.target.value === 'with';
        states.set(this._stateKey, this._withBox);
        this._sync();
      }

      _onKachingChange() {
        this._queueSync();
      }

      _onQuantityChange(event) {
        if (event.target?.name === 'quantity' && event.target.form === this._form) {
          this._queueSync();
        }
      }

      _onClick(event) {
        const submitter = event.target instanceof Element
          ? event.target.closest('button[type="submit"], input[type="submit"]')
          : null;
        const form = submitter?.form;
        if (!form || form.getAttribute('id') !== this.dataset.formId || !this._withBox) return;

        if (this._submittingSinglePair) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        const selectedBar = this._selectedBar;
        const integration = selectedBar ? this._bundleIntegration(selectedBar) : null;

        if (selectedBar && !integration) {
          this._blockSubmit(event, this.dataset.unavailableMessage);
          return;
        }

        const quantity = integration?.quantity || this._formQuantity();

        if (this._coverStock < quantity) {
          this._blockSubmit(event, this.dataset.unavailableQuantityMessage);
          return;
        }

        this._submitSinglePair(event, form, quantity, selectedBar);
      }

      _queueSync() {
        if (this._syncQueued) return;

        this._syncQueued = true;
        requestAnimationFrame(() => {
          this._syncQueued = false;
          this._sync();
        });
      }

      _sync() {
        const bar = this._selectedBar;
        const requiredQuantity = bar ? this._barQuantity(bar) : this._formQuantity();
        const integration = bar ? this._bundleIntegration(bar) : null;
        const integrationReady = !bar || Boolean(integration);
        const hasStock = this._coverStock >= requiredQuantity;
        const withInput = this.querySelector('[data-box-cover-choice][value="with"]');
        const withoutInput = this.querySelector('[data-box-cover-choice][value="without"]');
        const withLabel = this.querySelector('[data-box-cover-with-label]');
        const selectedValue = this.querySelector('[data-box-cover-selected-value]');
        const status = this.querySelector('[data-box-cover-status]');
        const canSelectWithBox = hasStock && integrationReady;

        withInput.disabled = !canSelectWithBox;
        withLabel.classList.toggle('is-disabled', !canSelectWithBox);
        withLabel.setAttribute('aria-disabled', String(!canSelectWithBox));

        if (!canSelectWithBox && this._withBox) {
          this._withBox = false;
          states.set(this._stateKey, false);
        }

        withInput.checked = this._withBox;
        withoutInput.checked = !this._withBox;
        this.dataset.withBox = String(this._withBox);
        this._root.dataset.boxCoverWithBox = String(this._withBox);
        const selectedLabel = this._withBox ? this.dataset.withLabel : this.dataset.withoutLabel;
        if (selectedValue.textContent !== selectedLabel) selectedValue.textContent = selectedLabel;

        if (!hasStock) {
          withLabel.title = this.dataset.soldOutMessage;
          if (status.textContent !== this.dataset.unavailableQuantityMessage) {
            status.textContent = this.dataset.unavailableQuantityMessage;
          }
          status.hidden = false;
        } else if (!integrationReady) {
          withLabel.title = this.dataset.unavailableMessage;
          if (status.textContent !== this.dataset.unavailableMessage) {
            status.textContent = this.dataset.unavailableMessage;
          }
          status.hidden = false;
        } else {
          withLabel.removeAttribute('title');
          status.hidden = true;
        }

        this._updateKachingPrices();
        this._updateNativePrice();
      }

      _formQuantity() {
        return Math.max(1, Number.parseInt(this._form?.querySelector('[name="quantity"]')?.value || '1', 10) || 1);
      }

      _barQuantity(bar) {
        const quantity = Number.parseInt(this._barDefinition(bar)?.quantity || bar.dataset.quantity || '0', 10);
        if (quantity > 0) return quantity;
        return 1;
      }

      _settings() {
        const selector = `script.kaching-bundles-deal-block-settings[type="application/json"][data-product-id="${this.dataset.productId}"]`;
        const nodes = document.querySelectorAll(selector);
        if (nodes.length !== 1) return null;

        try {
          return JSON.parse(nodes[0].textContent || '{}');
        } catch (error) {
          if (error instanceof SyntaxError) return null;
          throw error;
        }
      }

      _barDefinition(bar) {
        const settings = this._settings();
        if (!Array.isArray(settings?.dealBars)) return null;

        const matches = settings.dealBars.filter((candidate) => candidate.id === bar.dataset.dealBarId);
        return matches.length === 1 ? matches[0] : null;
      }

      _bundleIntegration(bar) {
        const definition = this._barDefinition(bar);
        const quantity = Number(definition?.quantity);
        const discount = Number(definition?.discountValue);
        if (
          !definition ||
          definition.dealBarType !== 'quantity-break' ||
          definition.quantitySelector !== false ||
          !Number.isInteger(quantity) ||
          quantity < 1 ||
          definition.discountType !== 'percentage' ||
          !Number.isFinite(discount) ||
          discount < 0 ||
          discount > 100
        ) return null;

        const productGID = `gid://shopify/Product/${this.dataset.coverProductId}`;
        const hasCoverUpsell = Array.isArray(definition.upsells) &&
          definition.upsells.some((upsell) => upsell.productGID === productGID);
        if (hasCoverUpsell) return null;

        return { definition, quantity, discount };
      }

      _onSubmit(event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || form.getAttribute('id') !== this.dataset.formId) return;

        if (this._submittingSinglePair) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        if (!this._withBox) return;

        const selectedBar = this._selectedBar;
        const integration = selectedBar ? this._bundleIntegration(selectedBar) : null;

        if (selectedBar && !integration) {
          this._blockSubmit(event, this.dataset.unavailableMessage);
          return;
        }

        const quantity = integration?.quantity || this._formQuantity();

        if (this._coverStock < quantity) {
          this._blockSubmit(event, this.dataset.unavailableQuantityMessage);
          return;
        }

        this._submitSinglePair(event, form, quantity, selectedBar);
      }

      _blockSubmit(event, message) {
        event.preventDefault();
        event.stopImmediatePropagation();
        document.dispatchEvent(new CustomEvent('toast:show', {
          detail: { message, tone: 'error' }
        }));
      }

      async _submitSinglePair(event, form, quantity, selectedBar) {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        const variantInput = form.querySelector('[name="id"]');
        const variantId = variantInput?.value;
        if (!variantId || !this.dataset.coverVariantId || this._coverStock < quantity) {
          this._showError(this.dataset.unavailableMessage);
          return;
        }

        const pairId = `box-cover-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const mainItem = this._mainItem(form, variantId, quantity, pairId);
        if (!mainItem) {
          this._showError(this.dataset.unavailableMessage);
          return;
        }

        if (selectedBar) {
          if (!this._hasValidKachingProperties(mainItem, selectedBar)) {
            this._showError(this.dataset.unavailableMessage);
            return;
          }
        } else {
          delete mainItem.properties.__kaching_bundles;
        }

        const submitButtons = Array.from(form.elements).filter((control) => control.type === 'submit');
        this._submittingSinglePair = true;
        submitButtons.forEach((button) => button.setAttribute('aria-busy', 'true'));
        const sections = new Set();
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections }
        }));

        try {
          const response = await fetch(`${Shopify.routes.root}cart/add.js?kaching_bundles=true`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Kaching-Cart-Ignore': '1',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [
                mainItem,
                {
                  id: this.dataset.coverVariantId,
                  quantity,
                  parent_id: variantId,
                  properties: {
                    _box_cover_pair: pairId,
                    _box_cover_role: 'cover'
                  }
                }
              ],
              sections: [...sections].join(',')
            })
          });
          const responseJson = await response.json();

          if (!response.ok) {
            form.dispatchEvent(new CustomEvent('cart:error', {
              bubbles: true,
              detail: { error: responseJson.message }
            }));
            this._showError(responseJson.message || this.dataset.unavailableMessage);
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            return;
          }

          if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
            window.location.href = `${Shopify.routes.root}cart`;
            return;
          }

          const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cart.sections = responseJson.sections;
          const items = responseJson.items || [responseJson];
          form.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: { items, cart }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart }
          }));
        } catch (error) {
          this._showError(this.dataset.unavailableMessage);
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } finally {
          this._submittingSinglePair = false;
          submitButtons.forEach((button) => button.removeAttribute('aria-busy'));
        }
      }

      _mainItem(form, variantId, quantity, pairId) {
        const item = {
          id: variantId,
          quantity,
          properties: {
            _box_cover_pair: pairId,
            _box_cover_role: 'primary'
          }
        };
        const formData = new FormData(form);

        for (const [name, value] of formData.entries()) {
          const propertyKey = name.match(/^properties\[(.+)\]$/)?.[1];
          if (propertyKey) {
            if (typeof value !== 'string') return null;
            item.properties[propertyKey] = value;
          } else if (name === 'selling_plan' && value) {
            item.selling_plan = value;
          }
        }

        return item;
      }

      _hasValidKachingProperties(item, bar) {
        const integration = this._bundleIntegration(bar);
        const rawProperties = item.properties?.__kaching_bundles;
        if (!integration || typeof rawProperties !== 'string') return false;

        try {
          const properties = JSON.parse(rawProperties);
          return properties?.main === true &&
            String(properties.pp) === this.dataset.productId &&
            properties.bid === integration.definition.id &&
            typeof properties.deal === 'string' && properties.deal.length > 0 &&
            typeof properties.v === 'string' && properties.v.length > 0;
        } catch (error) {
          if (error instanceof SyntaxError) return false;
          throw error;
        }
      }

      _showError(message) {
        document.dispatchEvent(new CustomEvent('toast:show', {
          detail: { message, tone: 'error' }
        }));
      }

      _updateKachingPrices() {
        this._root.querySelectorAll('.kaching-bundles__bar').forEach((bar) => {
          const integration = this._bundleIntegration(bar);
          const coverFullPrice = integration ? Number(this.dataset.coverPrice) * integration.quantity : 0;
          const saleExtra = this._withBox ? coverFullPrice : 0;
          const fullExtra = this._withBox ? coverFullPrice : 0;

          this._updateKachingMoneyNode(bar.querySelector('.kaching-bundles__bar-price'), saleExtra);
          this._updateKachingMoneyNode(bar.querySelector('.kaching-bundles__bar-full-price'), fullExtra);
          this._updateKachingMoneyNode(bar.querySelector('.kaching-bundles__bar-subtitle'), 0);
        });
      }

      _updateKachingMoneyNode(node, extraCents) {
        if (!node) return;

        const currentText = node.textContent.trim();
        const previousRenderedText = node.dataset.boxCoverRenderedText;
        let baseText = node.dataset.boxCoverBaseText;
        let parsed = this._parseMoney(currentText);

        if (!baseText || (currentText !== previousRenderedText && currentText !== baseText)) {
          if (!parsed) return;
          baseText = currentText;
          node.dataset.boxCoverBaseText = baseText;
          node.dataset.boxCoverBaseCents = String(parsed.cents);
        }

        const baseCents = Number.parseInt(node.dataset.boxCoverBaseCents || '', 10);
        if (!Number.isFinite(baseCents)) return;

        parsed = this._parseMoney(baseText);
        const baseMoney = this._formatMoney(baseCents);
        const desiredMoney = this._formatMoney(baseCents + extraCents);
        const desiredNumber = this._parseMoney(desiredMoney)?.token;
        let desiredText = baseText;

        if (baseText.includes(baseMoney)) {
          desiredText = baseText.replace(baseMoney, desiredMoney);
        } else if (parsed?.token && desiredNumber) {
          desiredText = baseText.replace(parsed.token, desiredNumber);
        } else if (baseText === currentText) {
          desiredText = desiredMoney;
        }

        if (currentText !== desiredText) node.textContent = desiredText;
        node.dataset.boxCoverRenderedText = desiredText;
      }

      _parseMoney(text) {
        const token = String(text).match(/-?\d[\d\s.,']*/g)?.at(-1)?.trim();
        if (!token) return null;

        let normalized = token.replace(/[\s']/g, '');
        const lastDot = normalized.lastIndexOf('.');
        const lastComma = normalized.lastIndexOf(',');
        const decimalIndex = Math.max(lastDot, lastComma);
        const hasDecimals = decimalIndex >= 0 && normalized.length - decimalIndex - 1 === 2;

        if (hasDecimals) {
          const decimalSeparator = normalized[decimalIndex];
          const thousandsSeparator = decimalSeparator === '.' ? ',' : '.';
          normalized = normalized.replaceAll(thousandsSeparator, '');
          normalized = normalized.replace(decimalSeparator, '.');
        } else {
          normalized = normalized.replace(/[.,]/g, '');
        }

        const amount = Number(normalized);
        return Number.isFinite(amount) ? { cents: Math.round(amount * 100), token } : null;
      }

      _updateNativePrice() {
        const basePrice = Number.parseInt(this.dataset.basePrice || '0', 10) || 0;
        const coverPrice = Number.parseInt(this.dataset.coverPrice || '0', 10) || 0;
        const formatted = this._formatMoney(basePrice + (this._withBox ? coverPrice : 0));
        const sticky = document.querySelector(`product-sticky-add-to-cart[main-product-form="${CSS.escape(this.dataset.formId)}"]`);
        const prices = [
          this._root.querySelector('[data-block-type="price"] sale-price'),
          sticky?.querySelector('sale-price')
        ];

        prices.forEach((price) => this._setPriceNode(price, formatted));
        this._updateStickyVariant(sticky);
      }

      _setPriceNode(price, formatted) {
        if (!price) return;

        const textNode = Array.from(price.childNodes).find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());

        if (textNode) {
          if (textNode.textContent.trim() !== formatted) textNode.textContent = formatted;
        } else {
          price.append(document.createTextNode(formatted));
        }
      }

      _updateStickyVariant(sticky) {
        const variant = sticky?.querySelector('.v-stack > span.subheading.text-subdued');
        if (!variant) return;

        const currentText = variant.textContent.trim();
        const previousRenderedText = variant.dataset.boxCoverRenderedText;
        let baseText = variant.dataset.boxCoverBaseText;

        if (!baseText || (currentText !== previousRenderedText && currentText !== baseText)) {
          baseText = currentText.replace(/\s*\/\s*(?:WITH|WITHOUT) BOX$/i, '');
          variant.dataset.boxCoverBaseText = baseText;
        }

        const packing = this._withBox ? this.dataset.withLabel : this.dataset.withoutLabel;
        const desiredText = `${baseText} / ${packing}`;
        if (currentText !== desiredText) variant.textContent = desiredText;
        variant.dataset.boxCoverRenderedText = desiredText;
      }

      _formatMoney(cents) {
        const format = this.dataset.moneyFormat || 'LE ' + '{' + '{amount}' + '}';
        const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || 'amount';
        const options = {
          amount: [2, ',', '.'],
          amount_no_decimals: [0, ',', '.'],
          amount_with_comma_separator: [2, '.', ','],
          amount_no_decimals_with_comma_separator: [0, '.', ','],
          amount_with_apostrophe_separator: [2, "'", '.']
        }[placeholder] || [2, ',', '.'];
        const number = (cents / 100).toFixed(options[0]);
        const parts = number.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, options[1]);
        const value = parts.length === 2 ? `${parts[0]}${options[2]}${parts[1]}` : parts[0];
        return format.replace(/\{\{\s*\w+\s*\}\}/, value).trim();
      }
    }

    if (!customElements.get('box-cover-picker')) {
      customElements.define('box-cover-picker', BoxCoverPicker);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
